import { httpInstance } from '@/services/httpInstance';

const postCommercialCategoryService = async (dataParam) => {
  let res;
  const endpoint = '/frontlabels/v1/business/details';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default postCommercialCategoryService;
